import { useEffect, useState } from 'react';
import axios from '../../api/axiosInstance';
import Loader from './components/Loader';
import ErrorBox from './components/ErrorBox';

export default function PinTrippins() {
  const search = new URLSearchParams(window.location.search);
  const businessId = search.get('business_id');

  const [trippins, setTrippins] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/trippins', { params: { business_id: businessId } })
      .then(({ data }) => {
        setTrippins(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  if (state === 'error') return <ErrorBox message="Failed to load trippins." />;

  return (
    <div className="mx-auto max-w-5xl space-y-6 p-6">
      <h1 className="text-xl font-semibold">Pin Trippins (max 3)</h1>

      <ul className="space-y-3">
        {trippins.map((t) => (
          <li
            key={t.id}
            className="flex items-center justify-between rounded-md border p-4"
          >
            <span>{t.title}</span>
            <button className="rounded bg-blue-600 px-3 py-1 text-xs text-white hover:bg-blue-700">
              {t.pinned ? 'Unpin' : 'Pin'}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
